
import { computed, defineComponent, onMounted, ref } from 'vue'
import { useStore } from '@/store/index'
import {
  PieEchart,
  RoseEchart,
  LineEchart,
  BarEchart,
  MapEchart
} from '@/compontents/page-echarts/index'
import ZpCard from '@/Base-UI/card/index'
export default defineComponent({
  name: 'dashboard',
  setup() {
    const store = useStore()
    const echartsRef = ref<HTMLElement>()
    store.dispatch('dashboard/getDashboardDataAction')

    /* 图表接口数据 */
    const categoryGoodsCount = computed(() => {
      return store.state.dashboard.categoryGoodsCount.map((item: any) => {
        return { name: item.name, value: item.goodsCount }
      })
    })
    /* 折线图数据 */
    const categoryGoodsSale = computed(() => {
      const title = '分类销量统计'
      const xLabels: string[] = []
      const values: any[] = []
      const categoryGoodsSale = store.state.dashboard.categoryGoodsSale
      for (const item of categoryGoodsSale) {
        xLabels.push(item.name)
        values.push(item.goodsCount)
      }
      return {
        title,
        xLabels,
        values
      }
    })
    /* 地图数据 */
    const addressGoodsSale = computed(() => {
      return store.state.dashboard.addressGoodsSale.map((item: any) => {
        return { name: item.address, value: item.count }
      })
    })
    return {
      echartsRef,
      categoryGoodsCount,
      categoryGoodsSale,
      addressGoodsSale
    }
  },
  components: {
    ZpCard,
    PieEchart,
    RoseEchart,
    LineEchart,
    BarEchart,
    MapEchart
  }
})
